import React from 'react';
import ExpensesPage from './ExpensesPage';
import ExpensesPageMobile from './ExpensesPageMobile';

const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 768;
};

const ExpensesPageWrapper: React.FC = () => {
  const [mobile, setMobile] = React.useState(isMobile());

  React.useEffect(() => {
    const handleResize = () => {
      setMobile(isMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mobile ? <ExpensesPageMobile /> : <ExpensesPage />;
};

export default ExpensesPageWrapper; 